<template>
    <layout-card :isCustomizable="settings.isCustomizable"
        :loading="loading"
        :type="settings.context"
        @edit-card="toggleSettingsForm"
        @hide-card="$emit('hide-card', type)"
        @refresh-card="fetchCard(type, {}, true)"
        class="card-turnover card-turnover_corp"
        :error="error"
        :class="{ 'card-turnover' : !error }"
        >
        <template #title>
            {{ name }}
        </template>

        <template #content>
            <template-turnover-card :data="cardData" :currencySymbol="settings.currencySymbol"/>
            <portal to="dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </portal>
        </template>
    </layout-card>
</template>

<script>
    import LayoutCard from './LayoutCard.vue';
    import CardMixin from './CardMixin.js';
    import TemplateTurnoverCard from './TemplateTurnoverCard.vue';

    export default {
        mixins : [CardMixin],
        components: {
            LayoutCard,
            TemplateTurnoverCard,
        },
        data() {
            return {
                settingsFormName : 'turnover-setting-form'
            };
        },
    }
</script>